import React from 'react';

const Tag = ({
  tagClass,
  tagText
}) => /*#__PURE__*/React.createElement("div", {
  className: "tag ".concat(tagClass)
}, tagText);

Tag.displayName = 'Tag';
Tag.defaultProps = {
  tagClass: '',
  tagText: ''
};
export default Tag;